import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GrowthWheelPagination from '../../components/GrowthWheelPagination/GrowthWheelPagination'
import { getPageTransitionClass } from '../../utils/growth-wheel-utils'
import { useGrowthWheelPagination } from '../../hooks/useGrowthWheelPagination'
import '../../css/growthWheel.scss'
import CompetencyAssessmentTitleCard from '../../components/GrowthWheelComponents/CompetencyAssessmentTitleCard'
import CompetencyAssessmentContent from '../../components/GrowthWheelComponents/CompetencyAssessmentContent'
import { useContentTransition } from '../../hooks/useContentTransition'
import BackButton from '../../components/GrowthWheelComponents/BackButton'
import { setCurrentCompetency } from '../../redux/growthWheel.slice'
import { RootState } from '../../redux/store'

const GrowthWheelCompetencyAssessment = () => {
  const dispatch = useDispatch()
  const currentCompetency = useSelector((state: RootState) => state.growthWheel.currentCompetency)
  const currentCompetencyArea = useSelector((state: RootState) => state.growthWheel.currentCompetencyArea)

  const competencyList = currentCompetencyArea?.competencies ?? []

  const handleClickCompetencyChange = (competency: Parameters<typeof setCurrentCompetency>[0]) => {
    dispatch(setCurrentCompetency(competency))
  }

  if (!currentCompetency) return null
  const { currentIndex, handlePrevious, handleNext } = useGrowthWheelPagination(
    competencyList,
    currentCompetency,
    handleClickCompetencyChange
  )
  const { isTransitioning, transitionDirection } = useContentTransition(currentIndex)

  return (
    <div className="container mb-5 gw-competency-area-view">
      <BackButton onClick={() => handleClickCompetencyChange(null)} text="Back to all competencies"  className="assessment-back-button"/>

      <div className={`gw-competency-area-view-content gw-competency-area-page ${getPageTransitionClass(isTransitioning, transitionDirection)}`}>
        <CompetencyAssessmentTitleCard
          name={currentCompetency.name}
          description={currentCompetency.description}
          isFocus={currentCompetency.evaluation?.focus}
          evaluationId={currentCompetency.evaluation?.id}
        />
      </div>

      <div className={`gw-competency-assessment-content ${getPageTransitionClass(isTransitioning, transitionDirection)}`}>
        <CompetencyAssessmentContent
          competency={currentCompetency}
        />
      </div>

      <GrowthWheelPagination
        currentIndex={currentIndex}
        optionsList={competencyList}
        handleClickPrevious={handlePrevious}
        handleClickNext={handleNext}
        type="Competency"
      />
    </div>
  )
}

export default GrowthWheelCompetencyAssessment